import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditPackage from "../../../Components/AddOrEditPackage/AddOrEditPackage";

const AddNewPackage = () => {
  return (
    <>
      <PageTitle
        title={"Add New Package"}
        BreadcrumbItems={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: "Package Management",
            link: "/package-management",
          },
          {
            title: "Add New Package",
          },
        ]}
      />
      <AddOrEditPackage />
    </>
  );
};

export default AddNewPackage;
